// Hairless brand wordmark: "Hairless" letterforms + official HAIRLESS badge
// plate. Ink rides currentColor; the badge text is knocked out in the
// inverted label color so the plate stays legible in both themes.

import type { IconProps } from './icons/props.ts'

/**
 * Render the full Hairless brand wordmark (text-rendered, theme-safe).
 * @param props.size - height in px (default 24; width keeps the 182:24 ratio).
 * @param props.className - extra class for layout placement.
 * @returns the wordmark svg (aria-hidden decorative brand art).
 */
export function BrandWordmark({ size = 24, className }: IconProps) {
  return (
    <svg
      width={(size * 182) / 24}
      height={size}
      className={className}
      viewBox="0 0 182 24"
      fill="none"
      aria-hidden="true"
    >
      <text
        x="0"
        y="18"
        fontSize="19"
        fontWeight="700"
        letterSpacing="0.5"
        fontFamily="system-ui, 'Segoe UI', Roboto, sans-serif"
        fill="currentColor"
      >
        Hairless
      </text>
      <rect x="129.348" y="5.5" width="52" height="14" rx="2" fill="currentColor" />
      <text
        x="155.348"
        y="15.6"
        fontSize="9.5"
        fontWeight="600"
        letterSpacing="1.2"
        fontFamily="system-ui, 'Segoe UI', Roboto, sans-serif"
        textAnchor="middle"
        fill="var(--dsw-alias-label-primary-inverted)"
      >
        HAIRLESS
      </text>
    </svg>
  )
}
